export const imageHeight = {
  full: 262,
  lg: 262,
  md: 200,
  sm: 160,
  xs: 112,
};
